import { createBillingAccount } from '../../common/fetch';
import { ReceiverTypes } from '../../common/utils/billingAccountUtils';
import { ContactType } from '../../generated/api/contactType';
import type { ReadyFormValues } from './CatalogConfigurationForm';
import type { PutBillingAccountResponse } from '../../generated/api/putBillingAccountResponse';

const catalogWizardStateKey = 'catalog-wizard-state';

export const getCatalogWizardState = <T>() => {
  if (typeof window === 'undefined') {
    return undefined;
  }

  const rawState = sessionStorage.getItem(catalogWizardStateKey);
  return rawState ? (JSON.parse(rawState) as T) : undefined;
};

export const setCatalogWizardState = (state: unknown) => {
  if (typeof window === 'undefined') {
    return;
  }

  sessionStorage.setItem(catalogWizardStateKey, JSON.stringify(state));
};

export const clearCatalogWizardState = () => {
  if (typeof window === 'undefined') {
    return;
  }

  sessionStorage.removeItem(catalogWizardStateKey);
};

export const createBillingAccountForCatalog = async (
  data: ReadyFormValues,
  mdmId?: string
): Promise<PutBillingAccountResponse> => {
  const billingContactId = data.billingAccount?.billingContactId;
  const billReceiverId = data.billReceiverSelection
    ? data.billReceiverSelection === ReceiverTypes.SAME_AS_CONTACT
      ? billingContactId
      : data.billingAccount?.billReceiverId
    : undefined;
  const billReceiverType = billReceiverId ? ContactType.PERSON : undefined;
  const catalogBa = data.billingAccount!;
  return await createBillingAccount(
    {
      ...catalogBa,
      billingContactId,
      billReceiverId,
      billReceiverType,
    },
    mdmId
  );
};
